export class StyleController
{
  // 要素のdisplayプロパティを設定、適用
  public applyDisplayToElement(style: CSSStyleDeclaration | undefined, display: string): void
  {
    if (style) style.display = display;
  }

  public clampValue(
    style: CSSStyleDeclaration | undefined,
    property: string,
    value: string,
    min: number,
    max: number,
  ): void
  {
    if (style)
    {
      const clamped = value.trim().split(/\s+/).map(part =>
      {
        // 正規表現で「数値 + 単位」を抽出（例: "10px", "50%", "2.5em"）
        const match = part.match(/^([-+]?\d*\.?\d+)([a-z%]*)$/i);

        if (match)
        {
          const num = parseFloat(match[1]);        // 数値部分（例: "10px" → 10）
          const unit = match[2];    // 単位部分（例: "10px" → "px"）
          const clamped_num = Math.min(Math.max(num, min), max); // クランプ処理

          return clamped_num + unit;                // 数値 + 単位 を組み立てて返す
        }

        // matchしない場合（例: "center", "auto", "inherit" などのキーワード）はそのまま返す
        return part;
      });

      // クランプ後の値を連結して、指定されたCSSプロパティに反映
      style.setProperty(property, clamped.join(' '));
    }
  }
}